import React, { createContext, useContext, useState } from "react";
import { SnackBar } from "../components/SnackBar";


interface SnackbarContextType {
    showSnackBar: (message: string | React.ReactNode, messageType?: string, duration?: number) => void;
}

const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined);

export const SnackbarProvider: React.FC<any> = ({ children }) => {
    const [snackbar, setSnackbar] = useState<{ message: string | React.ReactNode; open: boolean; messageType?: string, duration?: number }>({
        message: "",
        open: false,
    });

    const showSnackBar = (message: string | React.ReactNode, messageType?: string, duration?: number) => {
        setSnackbar({ message, open: true, messageType, duration });
    };

    const handleClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    return (
        <SnackbarContext.Provider value={{ showSnackBar }}>
            {children}
            <SnackBar message={snackbar.message} open={snackbar.open} handleClose={handleClose} messageType={snackbar.messageType || undefined} duration={snackbar.duration} />
        </SnackbarContext.Provider>
    );
};

export const useGlobalSnackBar = () => {
    const context = useContext(SnackbarContext);
    if (!context) {
        throw new Error("useGlobalSnackBar must be used within a SnackbarProvider");
    }
    return context;
};
